const APP_NAME = "Improve"
const ROUTE_PREFIX = "/pwa-improve"


export {APP_NAME, ROUTE_PREFIX};